import { ArrowRight, Award } from "lucide-react"

export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20">
      {/* Subtle grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {/* Left column - Main content */}
          <div className="lg:col-span-7 space-y-8">
            {/* Name with photo */}
            <div className="flex items-center gap-6">
              <div className="relative">
                <div className="w-20 h-20 rounded-full overflow-hidden ring-2 ring-primary/30 ring-offset-2 ring-offset-background">
                  <img 
                    src="/nick.jpeg" 
                    alt="Nick Bell" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div>
                <span className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-foreground font-medium">
                  Nick Bell
                </span>
                <div className="w-20 h-0.5 bg-primary mt-2" />
              </div>
            </div>

            {/* Main headline */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.1] tracking-tight text-balance">
              Cyber, Economic Crime &{" "}
              <span className="text-primary">National Resilience</span>{" "}
              Leader
            </h1>

            {/* Subheadline */}
            <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed max-w-xl">
              Former national policing leader with 30 years&apos; experience spanning
              cybercrime, economic crime, digital forensics and large-scale partnership delivery.
            </p>

            {/* Key roles */}
            <div className="flex flex-wrap gap-3">
              {["Non-Executive Director", "Senior Stakeholder Engagement", "Business Development"].map((role) => (
                <span
                  key={role}
                  className="text-xs tracking-wide px-4 py-2 border border-border/60 text-muted-foreground"
                >
                  {role}
                </span>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="#connect"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-primary text-primary-foreground text-sm font-medium tracking-wide hover:bg-primary/90 transition-colors group"
              >
                Connect with Me
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 border border-border text-foreground text-sm font-medium tracking-wide hover:border-primary/50 hover:text-primary transition-colors"
              >
                What I Do
              </a>
            </div>
          </div>

          {/* Right column - Award & Info */}
          <div className="lg:col-span-5 lg:pl-12">
            <div className="border-l border-border/50 pl-8 space-y-10">
              {/* Award highlight */}
              <div className="group">
                <div className="flex items-center gap-3 mb-3">
                  <Award className="w-5 h-5 text-primary" />
                  <span className="text-xs tracking-widest uppercase text-primary font-medium">
                    2023 Award
                  </span>
                </div>
                <span className="block font-serif text-xl lg:text-2xl text-foreground mb-2">
                  Outstanding Security Director of the Year
                </span>
                <span className="block text-sm text-muted-foreground">
                  Tackling Economic Crime Awards (TECAs)
                </span>
              </div>

              {/* Current role */}
              <div className="group">
                <span className="block text-xs tracking-widest uppercase text-muted-foreground mb-3">
                  Current Role
                </span>
                <span className="block font-serif text-xl lg:text-2xl text-foreground mb-2">
                  Police CyberAlarm Lead
                </span>
                <span className="block text-sm text-muted-foreground">
                  NPCC National Cyber Crime Team
                </span>
              </div>

              {/* Experience stat */}
              <div className="group">
                <span className="block font-serif text-4xl lg:text-5xl text-primary mb-2">
                  30+
                </span>
                <span className="block text-sm font-medium text-foreground tracking-wide">
                  Years in Policing
                </span>
                <span className="block text-xs text-muted-foreground mt-1">
                  Career detective & senior leader
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center gap-3 text-muted-foreground">
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-12 bg-border relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  )
}
